/* eslint-disable max-len */
import React, { useContext, useMemo, useState } from 'react';
import { Box, Tooltip } from '@mui/material';
import { LanguageContext } from '../../../../../../../../libs/Context';
import { CiImageOn } from 'react-icons/ci';
import { IoDocumentTextOutline } from 'react-icons/io5';

import MediaDrivePopup from '../../../MediaDrivePopup';
import { createFeedContext } from '../..';

const FeedAttachments = (props) =>
{
	const { requestT, externalFile } = props;
	const [ otherModuleFile, setOtherModuleFile ] = useState(externalFile);
	const { language } = useContext(LanguageContext);
	const [ footerActn, setFooterActn ] = useState(
		requestT === 'driveUpload' && [ 'image' ].includes(externalFile[0]?.type?.split('/')[0])
			? 'image_video'
			: null
	);

	const { createFeed } = useContext(createFeedContext);

	// Memoized calculations for feed conditions
	const feedConditions = useMemo(() =>
	{
		const mediaItems = createFeed?.media || [];
		const documentItems = mediaItems.filter((item) => item.type.startsWith('application/'));
		const mediaTypeItems = mediaItems.filter((item) =>
			item.type?.startsWith('image/') ||
            item.type?.startsWith('video/') ||
            item.type === 'youtube'
		);

		return {
			isPollCreated     : createFeed?.poll && Object.keys(createFeed?.poll).length > 0,
			isOccasionCreated : createFeed?.occasion && Object.keys(createFeed?.occasion).length > 0,
			isYoutubeAdded    : mediaItems.some((item) => item?.type === 'youtube'),
			linkData          : mediaItems.filter((item) => item.type === 'link'),
			documentCount     : documentItems.length,
			mediaCount        : mediaTypeItems.length,
			isDocsPresent     : documentItems.length > 0,
			isMediaPresent    : mediaTypeItems.length > 0
		};
	}, [ createFeed ]);

	const handleFooterActions = (val) =>
	{
		setFooterActn(footerActn === val ? null : val);
	};

	const handleMediaClick = () =>
	{
		// Allow media upload only if no documents are present and media count is less than 20
		if (!feedConditions.isDocsPresent &&
            !feedConditions.documentCount &&
            !feedConditions.isYoutubeAdded &&
            !feedConditions.isPollCreated &&
            !feedConditions.isOccasionCreated &&
            feedConditions.mediaCount < 20)
		{
			handleFooterActions('image_video');
		}
	};

	const handleDocumentClick = () =>
	{
		// Allow document upload only if no media is present and document count is less than 5
		if (!feedConditions.isMediaPresent &&
            !feedConditions.mediaCount &&
            !feedConditions.isYoutubeAdded &&
            feedConditions.documentCount < 5)
		{
			handleFooterActions('application');
		}
	};

	// Calculate disabled states
	const isMediaDisabled = feedConditions.isDocsPresent ||
                        feedConditions.documentCount > 0 ||
						feedConditions.isYoutubeAdded ||
						feedConditions.mediaCount >= 20 ||
						requestT === 'repost';

	const isDocumentDisabled = feedConditions.isMediaPresent ||
                             feedConditions.mediaCount > 0 ||
                             feedConditions.isYoutubeAdded ||
                             feedConditions.documentCount >= 5 ||
							requestT === 'repost';

	return (
		<>
			{/* Image/Video */}
			<Tooltip title={!isMediaDisabled && language?.attachment} placement='top' arrow>
				<Box
					sx={{
						width  : 'var(--pixel20)',
						height : 'var(--pixel20)',
						color  : isMediaDisabled ? '#868686' : 'inherit'
					}}
				>
					<CiImageOn
						style={{
							opacity       : isMediaDisabled ? 0.5 : 1,
							pointerEvents : isMediaDisabled ? 'none' : 'auto',
							cursor        : isMediaDisabled ? 'default' : 'pointer'
						}}
						fontSize={'var(--pixel20)'}
						onClick={handleMediaClick}
					/>
				</Box>
			</Tooltip>

			{/* Document */}
			<Tooltip title={!isDocumentDisabled && language?.docs} placement='top' arrow>
				<Box
					sx={{
						width  : 'var(--pixel20)',
						height : 'var(--pixel20)',
						color  : isDocumentDisabled ? '#868686' : 'inherit'
					}}
				>
					<IoDocumentTextOutline
						style={{
							opacity       : isDocumentDisabled ? 0.5 : 1,
							pointerEvents : isDocumentDisabled ? 'none' : 'auto',
							cursor        : isDocumentDisabled ? 'default' : 'pointer'
						}}
						fontSize={'var(--pixel20)'}
						onClick={handleDocumentClick}
					/>
				</Box>
			</Tooltip>

			{Boolean([ 'image_video', 'application' ].includes(footerActn ?? '')) &&
			<MediaDrivePopup
				handleClose={handleFooterActions}
				open={Boolean([ 'image_video', 'application' ].includes(footerActn ?? ''))}
				footerActn={footerActn}
				requestT={requestT}
				externalFile={otherModuleFile}
				setOtherModuleFile={setOtherModuleFile}
			/>
			}
		</>
	);
};

export default FeedAttachments;